import React from 'react';

import { TextInput } from 'Settings/TextInput';

import { Modal, Text } from './styles';

const DELETE_PHRASE = 'delete all data';

export default class DeleteAllDataModal extends React.Component {
	state = {
		enableDeleteBtn: false,
		value: '',
	};

	onInputChange = e => {
		this.setState(
			{
				value: e.target.value,
			},
			this.updateDeleteButtonState
		);
	};

	updateDeleteButtonState = () => {
		const { value } = this.state;

		this.setState({
			enableDeleteBtn: value && value.toLowerCase() === DELETE_PHRASE,
		});
	};

	render() {
		const { enableDeleteBtn, value } = this.state;
		const { onConfirm, onCancel, inProgress } = this.props;
		return (
			<Modal
				title={
					inProgress
						? 'Delete in-progress...'
						: 'Are you sure you want to delete all data?'
				}
				cancelLabel={!inProgress ? 'Cancel' : null}
				submitLabel="Ok"
				onClose={onCancel}
				onSubmit={enableDeleteBtn && !inProgress ? onConfirm : null}
			>
				{inProgress ? (
					'Please wait.'
				) : (
					<Text>
						<p>You are about to delete all data from the application.</p>
						<br />
						<p>This will remove:</p>
						<ul>
							<li>All spend data</li>
							<li>Automatic and manually-created opportunities</li>
							<li>All vendor classification override settings</li>
						</ul>
						<p>
							Any future upload of data will be classified according to the
							latest available version of the taxonomy. Opportunities and vendor
							classification overrides will need to be recreated.
						</p>
						<br />
						<TextInput
							value={value}
							name="deleteCheck"
							label={`Type [${DELETE_PHRASE.toUpperCase()}] in the box below and click OK.`}
							onChange={this.onInputChange}
						/>
					</Text>
				)}
			</Modal>
		);
	}
}
